import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import SegmentRow from './segmentRow';
import SegmentsIndex from './segmentsIndex';
import SegmentsEdit from './segmentsEdit';
import SegmentsEditModal from './segmentsEditModal';
import SegmentsForm from './segmentsForm';
import SegmentsRule from './segmentsRule';
import SegmentsRulesTransform from './segmentsRulesTransform';
import SegmentsPreview from './segmentsPreview';
import SegmentsEngagementShow from './segmentsEngagementShow';

export default angular.module('app.components.segments', [
  'ui.router',
  SegmentRow.name,
  SegmentsIndex.name,
  SegmentsEdit.name,
  SegmentsEditModal.name,
  SegmentsForm.name,
  SegmentsRule.name,
  SegmentsPreview.name,
  SegmentsEngagementShow.name,
])
  .config(function($stateProvider){
    $stateProvider
      .state('app.segments', {
        abstract: true,
        url: '/segments/:gameId',
        template: '<ui-view/>',
        data: {
          permissions: {
            except: ['anonymous', 'BUYER_ONLY'],
            redirectTo: 'login'
          }
        },
        resolve: {
          updateCurrentGame: function($stateParams,GamesResource,currentGame){
            return GamesResource.one($stateParams.gameId).get().then(game => {
              currentGame.onNext(game);
            });
          }
        }
      })
      .state('app.segmentRow.index', {
        url: '',
        template: '<segment-row></segment-row>',
        params: { new: null, type: null },
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.segmentRow.index');
          }
        }
      })
      .state('app.segments.index', {
        url: '',
        template: '<segments-index></segments-index>',
        params: { new: null, type: null },
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.segments.index');
          }
        }
      })
      .state('app.segments.showEngage', {
        url: '/engage/:id',
        template: '<segments-engagement-show></segments-engagement-show>',
        resolve: {
          $title: ($filter,$stateParams) => {
            return $filter('translate')('$state.app.segments.showEngage.show', {id: $stateParams.id});
          }
        }
      })
  })
  .filter('segmentLogic', function($filter) {
    return function(segment) {
      return SegmentsRulesTransform.toString(_.get(segment,'definition'), $filter('translate'));
    }
  })
  .directive('segmentName', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        segment: '='
      },
      template: `<span>{{ segment.name || ('new' | translateWith:'segment') }}
        <span ng-if='segment.type != "for_sale"' class="c-pill c-pill--orange u-ml--">Engagement</span>
      </span>`
    };
  })



/** WEBPACK FOOTER **
 ** ./src/components/segments/segments.js
 **/